import { Box } from '@achieve/ascend'
import { useInlineMemoizedContentGetter } from 'utils/contentful'
import { _isEmpty } from 'utils/shared'
import { LinkButton, MediaImageStandard, Typography } from 'components/Contentful'
import { Eyebrow } from 'components/Eyebrow'
import { IconListItem } from 'components/IconListItem'
import { BLOCKS } from '@contentful/rich-text-types'
import styles from './CardProductListItem.module.scss'
import AppStoreButtons from 'components/AppStoreButtons/AppStoreButtons'
import { mainProductConfig } from 'constants/mainProductConfig'
import {} from 'react'

const CardProductListItem = ({ content, index }) => {
  const {
    cardTitleText,
    cardLink,
    cardImage,
    iconCardItemCollection,
    eyebrow,
    linkAndroid,
    linkApple,
    imageApple,
    imageAndroid,
  } = useInlineMemoizedContentGetter(content, [
    'cardTitleText',
    'cardLink',
    'cardImage',
    'iconCardItemCollection',
    'eyebrow',
    'linkAndroid',
    'linkApple',
    'imageApple',
    'imageAndroid',
  ])
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  if (_isEmpty(content)) return null
  let cardLinkText = cardLink?.fields || cardLink
  cardLinkText = cardLinkText?.linkText?.json.content[0]?.content[0]?.value || 'Product Cards'

  return (
    <Box key={`item-${index}`} className={styles['cards-list-item']}>
      <Box className={styles['cards-list-item-image']}>
        <MediaImageStandard content={cardImage} layout="responsive" />
      </Box>
      {eyebrow && (
        <Eyebrow
          className={styles['cards-list-item-eyebrow']}
          content={eyebrow}
          variant="bodySm"
          fontWeight="bold"
          black
          data-testid="product-card-eyebrow"
        />
      )}

      {cardTitleText && (
        <Typography
          content={cardTitleText}
          variant="bodyLg"
          fontWeight="medium"
          data-testid="product-card-text"
        />
      )}

      <Box className={styles['cards-list-item-icons']}>
        {iconCardItemCollection?.items?.map((icon, iconIdx) => {
          return (
            <Box className={styles['cards-list-item-icons-item']} key={`item-icon-${iconIdx}`}>
              <IconListItem
                noList
                key={`icon-list-item-${iconIdx}`}
                cardTitleString={cardTitleText}
                iconColor={icon.iconColor}
                iconName={icon.iconName}
                itemText={icon.description}
                classNameIcon={styles['icon']}
                iconSize={20}
                noMarginBottom={iconIdx + 1 === iconCardItemCollection?.items?.length}
              />
            </Box>
          )
        })}
      </Box>

      {cardLink && (
        <LinkButton
          className={styles['button']}
          track={{
            ...{
              list_name: 'Recommended Card Link',
              click_position: index >= 0 ? index + 1 : '0',
              click_id: cardLinkText,
              click_text: `${mainProductConfig[siteEnv || 'achieve']} | ${cardLinkText}`,
              click_url: cardLink?.linkHref || cardLink?.fields?.linkHref,
              click_type: 'Button Click',
              nav_link_section: 'Product Cards',
              track_event: 'internal_campaign_click',
              event_action: 'button_click',
              event_type: 'button_click',
            },
            ...cardLink?.event,
          }}
          content={cardLink}
          typographicOptions={{
            variantOverride: { [BLOCKS.PARAGRAPH]: 'bodyLg' },
            fontWeight: 'bold',
          }}
          color="primary"
          variant={LinkButton.VARIANTS.CONTAINED}
          fullWidth={true}
          data-testid={`product-cards-section-card-button-text-${cardTitleText?.json?.content?.[0]?.content[0]?.value}`}
        />
      )}
      {(linkAndroid || linkApple) && (
        <div className={styles['app-container']}>
          <AppStoreButtons
            appleImage={imageApple}
            googleImage={imageAndroid}
            appleButton={linkApple}
            googleButton={linkAndroid}
            navLinkSection="Product Cards"
          />
        </div>
      )}
    </Box>
  )
}
export { CardProductListItem }
